module.exports = __webpack_public_path__ + "static/media/Amatic SC-01.073eddd4.svg";